export default __webpack_public_path__ + "static/media/logo_wide.84331bf4.png";